import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_NAME, LOGO, BLOG_LABEL } from "../../util/brand";
import { BRAND, hasFeature } from "../../brand";
import "../../../apps/public/src/components/Views/Home/Home.css";

import CondenseLogo from "./CondenseLogo";
import NewzAgentLogo from "./NewzAgentLogo";
import WebinarVaultLogo from "./WebinarVaultLogo";

const isNewzAgent = BRAND.id === "newzagent";
const isCondense = BRAND.id === "condense";
const isVideoBrief = BRAND.id === "videobrief";

function MainNav() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";
  const a = (hash) => isHome ? hash : `/${hash}`;
  const ASSET_TYPES = BRAND.marketing.assetTypes || [];
  const AD_CUE = BRAND.marketing.adCue || null;

  const navLinks = isNewzAgent
    ? [
        { href: a("#features"), label: "Features" },
        { href: a("#demo"), label: "Demo" },
      ]
    : isCondense
    ? [
        { href: a("#features"), label: "Features" },
        ...(ASSET_TYPES.length ? [{ href: a("#asset-types"), label: "Asset Types" }] : []),
        ...(AD_CUE ? [{ href: a("#ad-cue"), label: "Ad Cues" }] : []),
        { href: a("#personas"), label: "Use Cases" },
        { href: a("#demo"), label: "Demo" },
      ]
    : [
        { href: a("#features"), label: "Features" },
        { href: a("#personas"), label: "Use Cases" },
        { href: a("#demo"), label: "Demo" },
        { href: a("#pricing"), label: "Pricing" },
        ...(hasFeature("blog") ? [{ href: "/blog", label: BLOG_LABEL, internal: true }] : []),
      ];

  return (
    <nav className="home-nav">
      <div className="nav-inner">
        <Link to="/" className="logo">
          {isNewzAgent
            ? (
              <>
                <span className="logo-icon-mobile"><NewzAgentLogo height={36} color="#ffffff" accentColor="#ef4444" showWordmark={false} /></span>
                <span className="logo-full-desktop"><NewzAgentLogo height={36} color="#ffffff" accentColor="#ef4444" /></span>
              </>
            )
            : isCondense
            ? (
              <>
                <span className="logo-icon-mobile"><CondenseLogo height={36} color="#ffffff" accentColor="#22c55e" showWordmark={false} /></span>
                <span className="logo-full-desktop"><CondenseLogo height={36} color="#ffffff" accentColor="#22c55e" /></span>
              </>
            )
            : isVideoBrief
            ? (
              <>
                <img src={LOGO} alt={APP_NAME} className="logo-icon-mobile" style={{ height: 36, width: "auto" }} />
                <WebinarVaultLogo height={44} showTagline={false} className="logo-full-desktop" />
              </>
            )
            : <img src={LOGO} alt={APP_NAME} style={{ height: 44, width: "auto" }} />
          }
        </Link>
        <div className="nav-links">
          {navLinks.map((l) =>
            l.external
              ? <a key={l.href} href={l.href} className="nav-link" target="_blank" rel="noreferrer">{l.label}</a>
              : l.internal
              ? <Link key={l.href} to={l.href} className="nav-link">{l.label}</Link>
              : <a key={l.href} href={l.href} className="nav-link">{l.label}</a>
          )}
          <span style={{ display: "inline-block", width: 12 }} />
          <Link to="/login" className="btn-s btn-sm">Sign In</Link>
          <Link to="/register" className="btn-p btn-sm">Start Free Trial</Link>
        </div>
        <div className="nav-actions-mobile">
          <a href="/login" className="nav-signin-at" aria-label="Sign in">@</a>
          <button
            className="nav-hamburger"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Open menu"
          >
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="2" strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="nav-mobile-menu">
          {navLinks.map((l) =>
            l.external
              ? <a key={l.href} href={l.href} className="nav-mobile-link" target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)}>{l.label}</a>
              : l.internal
              ? <Link key={l.href} to={l.href} className="nav-mobile-link" onClick={() => setMenuOpen(false)}>{l.label}</Link>
              : <a key={l.href} href={l.href} className="nav-mobile-link" onClick={() => setMenuOpen(false)}>{l.label}</a>
          )}
          <Link to="/register" className="nav-mobile-link nav-mobile-cta" onClick={() => setMenuOpen(false)}>Start Free Trial</Link>
        </div>
      )}
    </nav>
  );
}

export default MainNav;
